/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 17:28:35
 * @FilePath: \mrc-base-frontend\src\service\api\pushMessageToken.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-07 15:10:04
 */
// 消息模板
import http from "../httpConfig";

const table = "mrbase_sys_message_push_map_user_and_token";

// 获取列表
export const getMessageTokenList = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-token-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//删除
export const deleteMessageTokenDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/delete-token/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
